module.exports = __webpack_public_path__ + "media/iconic/pencil-afed30ee.svg";